import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/v-model-test',
            name: 'admin-v-model-test',
            component: () => import(/* webpackChunkName: "page-admin-default-v-model-test" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "v-model-test"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "v-model-test"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
